import React, {
    Children,
    FC,
    ReactNode,
    useEffect,
    useState,
} from 'react'

interface StatusTableCarouselProps {
    autoSwipeDelay: number
    children: ReactNode
    className?: string
    onPageChange: (page: number) => void
    shouldRotate: boolean
}

export const StatusTableCarousel: FC<StatusTableCarouselProps> = ({
    autoSwipeDelay,
    children,
    className,
    onPageChange,
    shouldRotate,
}) => {
    const slides = Children.toArray(children)
    const slideCount = slides.length
    const [activePage, setActivePage] = useState(0)

    useEffect(() => {
        if (activePage >= slideCount) {
            setActivePage(0)
        }
    }, [activePage, slideCount])

    useEffect(() => {
        onPageChange(activePage)
    }, [activePage, onPageChange])

    useEffect(() => {
        if (!shouldRotate || slideCount <= 1) {
            return
        }

        const interval = window.setInterval(() => {
            setActivePage((page) => (page + 1) % slideCount)
        }, autoSwipeDelay * 1000)

        return () => window.clearInterval(interval)
    }, [autoSwipeDelay, shouldRotate, slideCount])

    return (
        <div
            className={className}
            style={{
                overflow: 'hidden',
                width: '100%',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    transform: `translateX(-${activePage * 100}%)`,
                    transition: 'transform 500ms ease',
                    width: '100%',
                }}
            >
                {slides.map((child, index) => (
                    <div
                        key={index}
                        style={{
                            flex: '0 0 100%',
                            minWidth: '100%',
                            width: '100%',
                        }}
                    >
                        {child}
                    </div>
                ))}
            </div>
        </div>
    )
}
